<template>
  <div style="margin: 0 auto">
    <!-- teeacher Dashboard -->
    <v-row v-if="weeks.length > 0">
      <v-col cols="12" offset-md="1" md="10" class="pa-0 mb-5">
        <v-row v-if="dashboard == 'teacher'">
          <v-col cols="4">
            <label for="ClassName">{{ $t("Class Name") }}: </label>
            <v-select
              :items="classes"
              item-text="class_name"
              item-value="id"
              v-model="selectedClass"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="6">
            <label for="ClassName">{{ $t("Week") }}: </label>
            <v-select
              :items="weeks"
              item-text="name"
              item-value="id"
              v-model.trim="selectedWeekId"
              dense
              outlined
            >
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.name }} {{ data.item.from }} : {{ data.item.to }}
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.name }} {{ data.item.from }} : {{ data.item.to }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-btn class="main-btn mt-md-8" @click="changeWeek">{{
              $t("Show")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- semester and quarter Select boxes -->
    <div
      class="card-body"
      style="margin-bottom: -5em !important"
      v-if="dashboard != 'teacher'"
    >
      <div class="card height-auto v-application--is-ltr text-left">
        <div class="card-body">
          <v-row class="headerTable-div">
            <v-col md="2" sm="4" class="">
              <p class="mt-2">Semester</p>
            </v-col>
            <v-col md="4" sm="8">
              <v-autocomplete
                :label="$t('semester')"
                :items="semesters"
                item-text="name"
                item-value="id"
                v-model="selectedSemester"
                solo
              ></v-autocomplete>
            </v-col>
            <v-col md="2" sm="4" class="">
              <p class="mt-2">Quarter</p>
            </v-col>
            <v-col md="4" sm="8">
              <v-autocomplete
                :label="$t('Quarters')"
                :items="quarters"
                item-text="name"
                item-value="id"
                v-model="selectedQuarter"
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <!-- weeks select -->
    <div class="header mb-0" v-if="weeks.length > 0 && dashboard != 'teacher'">
      <!-- Import/Export Button -->
      <v-btn
        big
        v-if="hasBulkEditWeeklyPlan"
        class="main-color"
        @click="OpenDialogImport"
        :title="$t('Import File')"
        style="background-color: transparent; box-shadow: none !important"
      >
        <img src="../../../src/assets/icons/upload.svg" />
      </v-btn>

      <!-- </v-btn> -->
      <v-btn
        big
        class="main-color"
        @click="printPdf"
        :title="$t('Print PDF')"
        style="background-color: transparent; box-shadow: none !important"
      >
        <v-icon large class="main-color">print</v-icon>
      </v-btn>

      <v-row>
        <v-col cols="12" md="6" style="margin: 0 auto" class="center">
          <div class="dates text-start" style="margin-left:6em">
            <v-icon style="color: #7195fa" @click="previousWeek">
              {{ "arrow_back_ios" }}
            </v-icon>
            {{ selectedWeekFrom }} - {{ selectedWeekTo }}
            <v-icon style="color: #7195fa" @click="nextWeek">
              {{ "arrow_forward_ios" }}
            </v-icon>
          </div>

          <v-select
            :items="weeks"
            item-text="name"
            item-value="id"
            v-model.trim="selectedWeekId"
            solo
            @change="changeWeek"
            style="float: left; width: 67%"
          >
            <template slot="selection" slot-scope="data">
              <!-- HTML that describe how select should render selected items -->
              {{ data.item.name }} - {{ data.item.from }} : {{ data.item.to }}
            </template>
            <template slot="item" slot-scope="data">
              <!-- HTML that describe how select should render items when the select is open -->
              {{ data.item.name }} - {{ data.item.from }} : {{ data.item.to }}
            </template>
          </v-select>
          <v-btn
            v-show="canConfirmWeeklyPlan && !weekDates[selectedWeekId].confirmed"
            class="main-btn"
            style="
              margin-right: 5px !important;
              height: 48px !important;
              width: 25%;
            "
            @click="changeStatus(selectedQuarter)"
            :disabled="loading"
            :loading="loading"
            >{{ $t("Confirm") }}
          </v-btn>
          <v-icon
            style="color: #7195fa; margin-top: 7px; font-size: 35px"
            v-show="!weekDates[selectedWeekId].confirmed"
          >
            {{ "check_circle" }}
          </v-icon>

          <v-btn
            v-show="canConfirmWeeklyPlan && weekDates[selectedWeekId].confirmed"
            class="main-btn"
            style="margin-right: 5px !important; height: 48px !important"
            @click="changeStatus(selectedQuarter)"
            :disabled="loading"
            :loading="loading"
            >{{ $t("Un Confirm") }}
          </v-btn>
          <span
            style="color: rgb(4, 83, 4); font-size: 16px; font-weight: bold"
            v-show="weekDates[selectedWeekId].confirmed"
          >
            {{ "Confirmed" }}
          </span>
        </v-col>
      </v-row>
    </div>
    
    <!-- class mangement weekly plan -->
    <v-row>
      <v-col cols="12" md="12" class="pa-0 mb-5">
        <div class="table-container" v-if="weeks.length > 0">
          <v-form ref="myForm" class="student-form" v-model="valid">
            <table class="scheduleTable weeklyPlan" style="width: 100%">
              <thead>
                <tr class="lesson-header">
                  <td class="day-column"></td>
                  <td
                    v-for="(lessonName, index) in scheduleLessonsNames"
                    :key="index"
                    class="lesson-td"
                  >
                    <span class="lesson-name mb-0">{{ lessonName.name }}</span>
                    <span
                      class="lesson-name mb-0"
                      v-if="!lessonName.name && editMode"
                    >
                      {{ "break" }}
                    </span>
                  </td>
                </tr>
                <tr class="time-header">
                  <td></td>
                  <td
                    v-for="(time, index) in schedulesFromTo"
                    :key="index"
                    class="time-item"
                  >
                    <span class="from">
                      {{ time.from ? getFullTime(time.from) : $t("From") }}
                    </span>
                    <span class="to">
                      {{ time.to ? getFullTime(time.to) : $t("To") }}
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody v-for="(schedule, dayIndex) in schedules" :key="dayIndex">
                <tr class="full-day">
                  <td class="day">
                    <span class="d-inline-block day-content">
                      {{ $t(schedule.day) }}
                      <v-icon
                        :title="schedule.day_notes"
                        style="font-size: 35px"
                        @click="openDayNoteModal(dayIndex)"
                        v-if="schedule.day_notes || canManageDayNotes"
                        color="white"
                        >{{ "speaker_notes" }}</v-icon
                      >
                    </span>
                  </td>
                  <td
                    :class="
                      lessonCard.subject && editable
                        ? 'lesson-card hover'
                        : 'lesson-card'
                    "
                    v-for="(lessonCard, index) in schedule.lessons"
                    :key="index"
                    @click="openModal(dayIndex, index)"
                  >
                    <div
                      v-if="
                        lessonCard.type == 'lesson' &&
                        lessonCard.class &&
                        !teacherId
                      "
                      class="class-item"
                    >
                      {{ lessonCard.class }}
                    </div>
                    <div
                      class="subject"
                      v-if="lessonCard.type == 'lesson' && !teacherId"
                    >
                      {{ lessonCard.subject }}
                    </div>
                    <div
                      class="teacher"
                      v-if="lessonCard.type == 'lesson' && !teacherId"
                    >
                      {{ lessonCard.teacher }}
                    </div>
                    <div
                      class="teacher"
                      v-if="
                        lessonCard.type == 'lesson' &&
                        lessonCard.lesson_id &&
                        !teacherId
                      "
                    >
                      <p
                        class="note"
                        :title="lessonCard.class_work_notes"
                        v-if="lessonCard.class_work_notes && !teacherId"
                      >
                        <span style="font-weight: bold">{{ $t("C.W") }}:</span>
                        {{
                          lessonCard.class_work_notes &&
                          lessonCard.class_work_notes.length >= 16
                            ? lessonCard.class_work_notes.substring(0, 15)
                            : lessonCard.class_work_notes
                        }}
                      </p>
                      <p
                        class="note"
                        :title="lessonCard.home_work_notes"
                        v-if="lessonCard.home_work_notes && !teacherId"
                      >
                        <span style="font-weight: bold">H.W:</span>
                        {{
                          lessonCard.home_work_notes &&
                          lessonCard.home_work_notes.length >= 16
                            ? lessonCard.home_work_notes.substring(0, 15)
                            : lessonCard.home_work_notes
                        }}
                      </p>
                      <p
                        class="note"
                        :title="lessonCard.notes"
                        v-if="lessonCard.notes && !teacherId"
                      >
                        <span style="font-weight: bold"
                          >{{ $t("Notes") }}:</span
                        >
                        {{
                          lessonCard.notes && lessonCard.notes.length >= 16
                            ? lessonCard.notes.substring(0, 15)
                            : lessonCard.notes
                        }}
                      </p>
                    </div>
                    <div
                      class="break"
                      v-if="lessonCard.type == 'break' && !teacherId"
                    >
                      <span>{{ $t("BREAK") }}</span>
                    </div>
                    <div v-if="teacherId" style="height: 100%">
                      <!-- v-for="(lessonItem, i) in lessonCard" -->
                      <div
                        :key="i"
                        class="lesson-container"
                        :class="lessonCard.type == 'break' ? 'full-height' : ''"
                      >
                        <div
                          v-if="
                            lessonCard.type == 'lesson' &&
                            lessonCard.subject &&
                            teacherId
                          "
                          class="single-lesson"
                          :class="lessonCard.current ? 'active' : ''"
                        >
                          <div class="subject-item">
                            {{
                              lessonCard.from
                                ? getFullTime(lessonCard.from) + " :"
                                : ""
                            }}
                            {{
                              lessonCard.to ? getFullTime(lessonCard.to) : ""
                            }}
                          </div>
                          <div class="class-item">{{ lessonCard.class }}</div>
                          <div class="subject-item">
                            {{ lessonCard.subject }}
                          </div>

                          <div
                            v-if="lessonCard.meeting_active && canOpenMeeting"
                          >
                            <a
                              target="_blank"
                              :href="FrameLink + lessonCard.meetingId"
                            >
                              <img
                                data-v-38104988
                                src="../../assets/elearning.svg"
                                width="25"
                              />
                              <strong class="main-color">{{
                                $t("Classroom")
                              }}</strong>
                            </a>
                          </div>

                          <div
                            class="teacher"
                            v-if="
                              lessonCard.type == 'lesson' &&
                              lessonCard.lesson_id
                            "
                          >
                            <p
                              class="note"
                              :title="lessonCard.class_work_notes"
                              v-if="lessonCard.class_work_notes"
                            >
                              <span style="font-weight: bold"
                                >C.W. {{ $t("Notes") }}:</span
                              >
                              {{
                                lessonCard.class_work_notes &&
                                lessonCard.class_work_notes.length >= 16
                                  ? lessonCard.class_work_notes.substring(0, 15)
                                  : lessonCard.class_work_notes
                              }}
                            </p>
                            <p
                              class="note"
                              :title="lessonCard.home_work_notes"
                              v-if="lessonCard.home_work_notes"
                            >
                              <span style="font-weight: bold"
                                >H.W. {{ $t("Notes") }}:</span
                              >
                              {{
                                lessonCard.home_work_notes &&
                                lessonCard.home_work_notes.length >= 16
                                  ? lessonCard.home_work_notes.substring(0, 15)
                                  : lessonCard.home_work_notes
                              }}
                            </p>
                            <p
                              class="note"
                              :title="lessonCard.notes"
                              v-if="lessonCard.notes"
                            >
                              <span style="font-weight: bold"
                                >{{ $t("Notes") }}:</span
                              >
                              {{
                                lessonCard.notes &&
                                lessonCard.notes.length >= 16
                                  ? lessonCard.notes.substring(0, 15)
                                  : lessonCard.notes
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="break"
                          v-if="lessonCard.type == 'break' && teacherId"
                        >
                          <span>{{ $t("BREAK") }}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-form>
        </div>
        <div v-else class="no-data text-center">
          {{ $t("No data available") }}
        </div>
        <v-dialog
          v-model="AddEditdialog"
          persistent
          max-width="500px"
          scrollable
          v-if="editable || (!editable && teacherId)"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("Add Notes") }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12" sm="12" md="12" style="text-align: center;">
                <div v-if="errMessage">
                  <p class="red--text">
                    {{ errMessage }}
                  </p>
                </div>
              </v-col>-->
                  <v-col cols="12" sm="12" md="12">
                    <label style="margin-top: 16px !important">{{
                      $t("Classwork Notes")
                    }}</label>
                    <v-textarea
                      v-model="editedItem.class_work_notes"
                      solo
                      rows="3"
                      :readonly="!editable && teacherId"
                      style="font-size: 13px"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>{{ $t("Homework Notes") }}</label>
                    <v-textarea
                      v-model="editedItem.home_work_notes"
                      solo
                      rows="3"
                      :readonly="!editable && teacherId"
                      style="font-size: 13px"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>{{ $t("Notes") }}</label>
                    <v-textarea
                      v-model="editedItem.notes"
                      solo
                      rows="3"
                      :readonly="!editable && teacherId"
                      style="font-size: 13px"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn class="modal-btn-cancel" @click="close">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                class="modal-btn-save"
                @click="saveNotes(selectedQuarter)"
                :loading="loading"
                :disabled="loading"
                v-if="!teacherId"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="AddEditDayNoteDialog"
          persistent
          max-width="500px"
          scrollable
          :retain-focus="false"
          v-if="editable && canManageDayNotes"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("Add Day Notes") }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    style="text-align: center; margin-top: 20px"
                  >
                    <p class="main-color class-item">{{ $t(noteOnDay) }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>{{ $t("Day Notes") }}</label>
                    <ckeditor
                      :editor="editor"
                      v-model="editedItemDay.day_notes"
                      :config="editorConfig"
                      solo
                      style="font-size: 13px"
                    >
                    </ckeditor>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn class="modal-btn-cancel" @click="closeDayNotesDialog">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                class="modal-btn-save"
                @click="saveDayNotes(selectedQuarter)"
                :loading="loading"
                :disabled="loading"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- import modale -->
    <v-dialog
      v-model="ImportDialog"
      v-if="hasBulkEditWeeklyPlan"
      persistent
      max-width="500px"
      scrollable
    >
      <v-card>
        <v-card-title>
          <span class="headline"> {{ $t("Import") }} </span>

          <v-spacer></v-spacer>

          <v-icon class="main-color" @click="Close">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
          <v-container>
            <div v-if="uploadingError">
              <v-row class="buttons-space">
                <v-icon :color="colorIcon" class="iconSpace"
                  >attach_file</v-icon
                >
                <v-spacer></v-spacer>
                <v-icon :color="colorIcon" v-if="successMsg != ''">done</v-icon>
                <v-icon :color="colorIcon" v-if="errorIcon">error</v-icon>

                <v-progress-linear
                  rounded
                  :color="colorIcon"
                  :indeterminate="indeterminate"
                  height="10"
                  :value="valueProgress"
                  striped
                ></v-progress-linear>
              </v-row>

              <v-row
                style="
                  margin-top: 25px !important;
                  margin-bottom: 7px !important;
                "
              >
                <div>
                  <p
                    class="success--text text-center margin-auto"
                    role="alert"
                    style="margin-top: -15px !important"
                    v-if="successMsg != ''"
                  >
                    {{ successMsg }}
                  </p>
                  <br />
                </div>
                <div v-if="Object.keys(validation_errors).length !== 0">
                  <p v-for="(error, index) in validation_errors" :key="index">
                    <v-icon class="main-color">error</v-icon> {{ error }}
                  </p>
                </div>
              </v-row>
              <v-row>
                <v-col sm="6"></v-col>
                <v-col md="3" sm="3">
                  <v-btn class="modal-btn-save" @click="Back"
                    >{{ $t("Back") }}
                  </v-btn>
                </v-col>

                <v-col md="3" sm="3">
                  <v-btn class="modal-btn-cancel" @click="Close"
                    >{{ $t("Close") }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-if="importDiv">
              <v-row class="buttons-space">
                <v-col md="12" sm="12">
                  <div class="custom-file" id="upload-photo">
                    <input
                      type="file"
                      accept=".xlsx, .xls, .csv"
                      class="custom-file-input"
                      ref="fileObject"
                    />
                    <label class="custom-file-label" for="customFile">
                      <br
                    /></label>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6"></v-col>
                <v-col md="3" sm="3">
                  <v-btn class="modal-btn-save" @click="Back"
                    >{{ $t("Back") }}
                  </v-btn>
                </v-col>

                <v-col md="3" sm="3">
                  <v-btn class="modal-btn-save" @click.prevent="uploadFile"
                    >{{ $t("Import") }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-if="importFile">
              <v-row class="buttons-space">
                <v-col md="6" sm="6">
                  <v-btn class="modal-btn-download" @click="getTemplate()"
                    >{{ $t("Download Template") }} <br /><v-spacer></v-spacer
                    ><img
                      width="30px"
                      title="Download File"
                      src="../../../src/assets/icons/download.svg"
                  /></v-btn>
                </v-col>
                <v-col md="6" sm="6">
                  <v-btn class="modal-btn-import" @click="ShowImportDiv"
                    >{{ $t("Import") }}
                    <v-spacer></v-spacer>
                    <img
                      title="Import File"
                      width="30px"
                      src="../../../src/assets/icons/upload-white.svg"
                      class="color"
                  /></v-btn>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { weeklyPlanMixin } from "../../mixins/schedules/weeklyPlanMixin";
import Editor from "../../../ckeditor-build/build/ckeditor";
import importComponent from "../modals/importComponent";
import ACL from "../../acl";
import axios from "axios";

export default {
  mixins: [weeklyPlanMixin],
  comments: {
    importComponent,
  },
  props: ["editable", "dashboard"],
  data() {
    return {
      templateUrlLink: "",
      i: 0,
      ImportDialog: false,
      error: "",
      errorIcon: false,
      successMsg: "",
      validation_errors: {},
      importDiv: false,
      uploadingError: false,
      importFile: true,
      colorIcon: "blue",
      canOpenMeeting: ACL.Role("Teacher") || ACL.Role("Student"),
      canConfirmWeeklyPlan: ACL.checkPermission("confirm-weekly-plan"),
      FrameLink: window.location.origin + "/zoomIframe/",
      schedules: [],
      scheduleLessonsNames: [],
      schedulesFromTo: [],
      weekDates: [],
      daysLessonsIds: [],
      weekStartDate: "",
      weekEndDate: "",
      editMode: false,
      //academicId: this.$router.currentRoute.params.academicYear,
      //classId: this.$router.currentRoute.params.classId,
      loading: false,
      valid: false,
      editedItem: {
        class_work_notes: "",
        home_work_notes: "",
        notes: "",
        lesson_id: "",
        academic_week_id: "",
      },
      editedItemDay: {
        day_notes: "",
        week_day: "",
        week_day_id: "",
        academic_week_id: "",
        class_id: "",
      },
      editedWeekDay: "",
      currentQuarterAndWeek: {},
      selectedWeekId: "",
      selectedWeekFrom: "",
      selectedWeekTo: "",
      AddEditdialog: false,
      AddEditDayNoteDialog: false,
      noteOnDay: "",
      canManageDayNotes: ACL.checkPermission("manage-day-notes"),
      hasBulkEditWeeklyPlan: ACL.checkPermission("excel-bulk-edit-weekly-plan"),
      classes: [],
      selectedClass: "",
      editor: Editor,
      editorConfig: {
        toolbar: {
          shouldNotGroupWhenFull: true,
        },
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "/upload-ckeditor-image",
          headers: {
            "X-CSRF-TOKEN": "CSRF-Token",
            Authorization:
              "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImIwZDUyMDQ5NzA3YWM4MmMxNTFlMjhjOWYyODVjMzZiOWY4NDg0Y2Q2MDVkNjFlZTM0ZWVkMzYwMGUyNDk5NTU5YTc3OWFiNzczMGY1MjAwIn0.eyJhdWQiOiIxIiwianRpIjoiYjBkNTIwNDk3MDdhYzgyYzE1MWUyOGM5ZjI4NWMzNmI5Zjg0ODRjZDYwNWQ2MWVlMzRlZWQzNjAwZTI0OTk1NTlhNzc5YWI3NzMwZjUyMDAiLCJpYXQiOjE2ODEyMDg1NzAsIm5iZiI6MTY4MTIwODU3MCwiZXhwIjoxNjgyNDE4MTcwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.iKKZr4VyPPL-p_2eMJeYt4pCBF-a6vwll38VonW9P97BkeDjl6cBm1K4h3YcQ5dyBKu1FnRaOxf6rK-vPAD6BrUKhXLATV14gjeHM-Pxy1aY1XTRJep-W1tNP2eNDjQWW8xRed1nkT5VHvpSQfKYju_dqj2VpjjNOvbK3GFHlvf4XOHX_1wK64wBjUbgrpGNTmdzkWBuE8IXb9E5RwRpOMSZaIywsws2gwCPk9MeED65B_8qFPaTrKWCl0K-G4CoSAUyIUzaaNGlwUhMrlUZHl2bKflJLINdMsj8RjKavLOLGAZpJLjUWkEJGf9-jEXV0MWtGBir0Et8G90UFFTlzFguRjiVIaIbQ_O-sRw-cgE8xi1_HgskDVzOQ9zZwWoWaTBN0rqQzK2sD_d8eJuPlpTlraM6yUSr9KnOLkcypUtsHQt5A2lPn8DpYdCwLHTVtub2UHBF1rl3ft-TwWrbO-tw6Kgl-cTYSw90zA09gUofrklB1fNn7_og1crcxNkmLPpGXIkkao3u-CM87_H--8HSltinvWjHP3dTcSJgRXTA8JjmTqVH-bEnH-q5twkkwVCTpDTlsY9uTFk6XnJ2aXOtcF-ZMxSe2bfuyIwecJc-OfAdAMNpaJUHqmJR7Xg4YY4rlYpC4JtzFsfqLlSD9KJWKA7y1xXPe4bL58Vc_JQ",
            enctype: "multipart/form-data",
          },
        },
      },
      selectedSemester: "",
      selectedQuarter: "",
      semesters: [],
      quarters: [],
    };
  },
  watch: {
    selectedSemester: {
      handler() {
        this.weeks = [];
        this.selectedWeekId = "";
        this.selectedQuarter = "";
        this.getQuarters(this.selectedQuarter);
      },
    },
    selectedQuarter: {
      handler() {
        this.weeks = [];
        this.selectedWeekId = "";
        if (this.selectedQuarter) {
          this.getNotes(this.selectedQuarter);
        }
      },
    },
  },
  methods: {
    Close() {
      this.reset();
      this.ImportDialog = false;
      window.location.reload();
      // this.$emit("childImportToParent", false);
    },
    ShowImportDiv() {
      this.importDiv = true;
      this.importFile = false;
      this.uploadingError = false;
      this.colorIcon = "blue";
    },
    reset() {
      this.error = "";
      this.successMsg = "";
      this.validation_errors = {};
      this.errorIcon = false;
      this.importFile = true;
      this.importDiv = false;
      this.uploadingError = false;
      this.colorIcon = "blue";
    },
    getTemplate() {
      var yearId = this.$router.currentRoute.params.academicYear;
      var classId = this.$router.currentRoute.params.classId;
      axios
        .get(
          this.getApiUrl +
            "/weekly_plans/get/" +
            yearId +
            "/" +
            classId +
            "/" +
            this.selectedWeekId +
            "?excel_export=true",
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            let printLink = response.data.data;
            window.open(printLink, "_blank");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    printPdf() {
      var yearId = this.$router.currentRoute.params.academicYear;
      var classId = this.$router.currentRoute.params.classId;
      axios
        .get(
          this.getApiUrl +
            "/weekly_plans/get/" +
            yearId +
            "/" +
            classId +
            "/" +
            this.selectedWeekId +
            "?pdf_print=true",
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            let printLink = response.data.data;
            window.open(printLink, "_blank");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    uploadFile() {
      // var yearId = this.$router.currentRoute.params.academicYear;
      // var classId = this.$router.currentRoute.params.classId;
      let url = "/weekly_plans/store/";
      this.reset();
      this.importDiv = false;
      this.uploadingError = true;
      this.importFile = false;
      //   define formdata object
      const fd = new FormData();
      // check if there is a file
      //   console.log(this.$refs.fileObject.files);
      if (this.$refs.fileObject.files.length > 0) {
        // assign a key to the file
        console.log("ids", JSON.stringify(this.daysLessonsIds));
        fd.append("file", this.$refs.fileObject.files[0]);
        fd.append("academic_week_id", this.selectedWeekId);
        fd.append("excel_import", true);
        fd.append("week_start", this.selectedWeekFrom);
        fd.append("week_end", this.selectedWeekTo);
        fd.append("day_lessons", JSON.stringify(this.daysLessonsIds));
        axios
          .post(this.getApiUrl + url, fd, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then((response) => {
            // if validation error
            if (response.data) {
              if (
                response.data.status.error &&
                response.data.status.validation_errors.length != 0 &&
                Object.keys(response.data.status.validation_errors).length != 0
              ) {
                //console.log(response.data.status.validation_errors);
                this.errorIcon = true;
                this.validation_errors = response.data.status.validation_errors;
                this.colorIcon = "red";
                this.valueProgress = 20;
              } else if (
                (response.data.status.error &&
                  response.data.status.validation_errors.length == 0) ||
                (response.data.status.error &&
                  Object.keys(response.data.status.validation_errors).length ===
                    0 &&
                  response.data.status.validation_errors.constructor === Object)
              ) {
                //console.log(response.data.status.validation_errors);
                this.errorIcon = true;
                this.validation_errors = [response.data.status.message];
                this.colorIcon = "red";
                this.valueProgress = 20;
              } else {
                this.successMsg = response.data.status.message;
                this.errorIcon = false;
                this.colorIcon = "green";
                this.valueProgress = 100;
              }
              this.indeterminate = false;
            }
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        this.valueProgress = 0;
        this.indeterminate = false;
        this.error = "Please select file first";
        this.colorIcon = "red";
        this.errorIcon = true;
        this.validation_errors = ["Please select file first"];
      }
    },
    Back() {
      this.importDiv = false;
      this.importFile = true;
      this.uploadingError = false;
      this.colorIcon = "blue";
    },
    OpenDialogImport() {
      this.ImportDialog = true;
    },
    getClasses() {
      axios
        .get(this.getApiUrl + "/teachers/classes", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((res) => {
          this.classes = res.data.data;
        });
    },
    getFullTime(time) {
      var type = "";
      var H = time.split(":")[0];
      var M = time.split(":")[1];
      if (H == "00") {
        H = 12;
        type = this.$i18n.t("AM");
      } else if (H == "12") {
        type = this.$i18n.t("PM");
      } else if (parseInt(H) > 12) {
        type = this.$i18n.t("PM");
        H = H % 12;
      } else if (parseInt(H) < 12) {
        type = this.$i18n.t("AM");
      }
      return H + ":" + M + " " + type;
    },
    openModal(dayIndex, lesson_index) {
      if (
        this.schedules[dayIndex].lessons[lesson_index].subject &&
        !this.weekDates[this.selectedWeekId].confirmed
      ) {
        this.editedItem = {
          class_work_notes:
            this.schedules[dayIndex].lessons[lesson_index].class_work_notes,
          home_work_notes:
            this.schedules[dayIndex].lessons[lesson_index].home_work_notes,
          notes: this.schedules[dayIndex].lessons[lesson_index].notes,
          lesson_id: this.schedules[dayIndex].lessons[lesson_index].lesson_id,
          academic_week_id: this.selectedWeekId,
        };
        console.log(this.editedItem);
        this.AddEditdialog = true;
      }
    },
    openDayNoteModal(dayIndex) {
      if (!this.weekDates[this.selectedWeekId].confirmed) {
        this.noteOnDay = this.schedules[dayIndex].day;
        this.editedItemDay = {
          day_notes: this.schedules[dayIndex].day_notes,
          week_day: this.schedules[dayIndex].day,
          week_day_id: this.schedules[dayIndex].day_id,
          academic_week_id: this.selectedWeekId,
          class_id: this.classId,
        };
        this.AddEditDayNoteDialog = true;
      }
    },
    close() {
      this.editedItem = {
        class_work_notes: "",
        home_work_notes: "",
        notes: "",
        lesson_id: "",
        academic_week_id: "",
      };
      this.AddEditdialog = false;
    },
    closeDayNotesDialog() {
      this.editedItemDay = {
        day_notes: "",
        week_day: "",
        academic_week_id: "",
        class_id: "",
      };
      this.AddEditDayNoteDialog = false;
    },
    changeWeek() {
      this.selectedWeekFrom = this.weekDates[this.selectedWeekId].from;
      this.selectedWeekTo = this.weekDates[this.selectedWeekId].to;
      this.getNotes(this.selectedQuarter);
    },
    nextWeek() {
      let selectedWeekId = this.selectedWeekId;
      let takeNext = false;
      let _this = this;
      Object.keys(this.weekDates).forEach(function (key) {
        if (takeNext) {
          _this.selectedWeekId = parseInt(key);
          _this.selectedWeekFrom = _this.weekDates[key].from;
          _this.selectedWeekTo = _this.weekDates[key].to;
          takeNext = false;
        }
        if (key == selectedWeekId) {
          takeNext = true;
        }
      });
      this.getNotes(this.selectedQuarter);
    },
    previousWeek() {
      // console.log("here");
      let selectedWeekId = this.selectedWeekId;
      let takelast = false;
      let last = null;
      let _this = this;
      Object.keys(this.weekDates).forEach(function (key) {
        if (key == selectedWeekId) {
          takelast = true;
        }
        if (takelast && _this.weeks[0].id != key) {
          _this.selectedWeekId = parseInt(last);
          _this.selectedWeekFrom = _this.weekDates[last].from;
          _this.selectedWeekTo = _this.weekDates[last].to;
          takelast = false;
        }
        last = key;
      });
      this.getNotes(this.selectedQuarter);
    },
    getSemesters() {
      axios
        .get(this.getApiUrl + "/performance/getSemestersFilter", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.semesters = response.data.data;
          this.semesters.forEach((semester) => {
            if (semester.isCurrentSemesterId) {
              this.selectedSemester = semester.id;
            }
          });
          this.getQuarters();
        });
    },
    getQuarters() {
      if (this.selectedSemester != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getQuarterFilterBySemester/" +
              this.selectedSemester,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.quarters = response.data.data;
            this.quarters.forEach((quarter) => {
              if (quarter.isCurrentQuarterId) {
                this.selectedQuarter = quarter.id;
              }
            });
            if (this.selectedQuarter == "") {
              this.selectedQuarter = this.quarters[0].id;
            }
          });
      }
    },
  },
  mounted() {
    // console.log("role", ACL.Role("Teacher"));
    // setTimeout(
    // () => {
    this.getSemesters();
    // },
    // this.HiddenNoData ? 1000 : 0
    // );
    localStorage.activeTab = 2;
    // this.drawTable();
    this.getClasses();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/ScheduleTable.css";
@import "../../styles/_variables.scss";

.full-day {
  .day {
    position: relative;
    .day-content {
      transform: rotate(-90deg);
      background-color: $third-color;
      color: #fff;
      padding: 0 7px;
      border-radius: 8px 8px 0 0;
      position: absolute;
      right: -40px;
    }
  }
}

.lesson-header {
  .lesson-name {
    text-align: center;
    position: absolute;
    padding-bottom: 0;
    font-size: 20px;

    left: 38%;
    border: 1px solid $third-color;
    border-bottom: 0;
    display: inline-block;
    padding: 4px 20px;
    top: -12px;
    border-radius: 10px 10px 0 0;

    width: auto !important;
  }
  .lesson-name.active {
    background-color: $third-color;
    color: #fff;
  }
}

.single-lesson.active {
  border: 1px solid $third-color;
  box-shadow: 0 0 6px 0 var(--robins-egg);
}
</style>
